import { defineComponent as a } from "vue";
import { MsHeadlineType as t } from "./index572.js";
const i = a({
  name: "MsHeadline",
  props: {
    type: {
      default: t.H1,
      type: String
    },
    isBold: {
      default: !0,
      type: Boolean
    },
    isSpan: {
      default: !1,
      type: Boolean
    }
  },
  setup(e) {
    function n() {
      return e.isSpan ? "span" : e.type;
    }
    return {
      MsHeadlineType: t,
      getTag: n
    };
  }
});
export {
  i as default
};
